export default __webpack_public_path__ + "static/media/screen6.763fdbc4.png";